import script from "./SolutionTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionTemplates.vue?vue&type=script&setup=true&lang=js"

import "./SolutionTemplates.vue?vue&type=style&index=0&id=3f203bc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f203bc4"]])

export default __exports__